/**
 * Converts a data url string to a blob
 */
export default async function dataUrlToBlob(dataUrl: string): Promise<Blob> {
  return new Promise(resolve => {
    fetch(dataUrl).then(res => resolve(res.blob()));
  });
}
